import { useFeatureFlag } from '@airreading/feature-flags/web';

import { SessionScheduleCalendarLegacy } from './session-schedule-calendar-legacy.js';
import { SessionScheduleCalendarScheduleX } from './session-schedule-calendar-schedule-x.js';
import type { SessionScheduleProps } from './session-schedule-calendar-types.js';

/**
 * Coach “My classes” calendar. LaunchDarkly flag `coach-calendar-schedule-x` selects
 * Schedule-X vs react-big-calendar (legacy).
 */
export function SessionScheduleCalendar(props: SessionScheduleProps) {
  const scheduleXCalendarEnabled = useFeatureFlag('coach-calendar-schedule-x', false);

  if (scheduleXCalendarEnabled) {
    return <SessionScheduleCalendarScheduleX {...props} />;
  }

  return <SessionScheduleCalendarLegacy {...props} />;
}

/**
 * Calendar types and view list. `CalendarView` is an alias of `CoachCalendarView`; both
 * `CalendarView` and `coachCalendarSupportedViews` are defined in `@/lib/my-classes-utils`
 * and re-exported via `session-schedule-calendar-types`.
 */
export type {
  CalendarView,
  ConcreteEvent,
  ExpandedEvent,
  EventsWithContext,
  SessionScheduleProps,
} from './session-schedule-calendar-types.js';

// eslint-disable-next-line react-refresh/only-export-components
export { coachCalendarSupportedViews } from './session-schedule-calendar-types.js';
// eslint-disable-next-line react-refresh/only-export-components
export { eventsFromSessions } from './session-schedule-calendar-shared.js';
